import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { memo, useRef } from 'react';
import useViewbox from '../../useViewbox.js';
const SvgErrorFilled = memo((componentProps) => {
    const ref = useRef(null);
    useViewbox(ref);
    const props = {
        ...componentProps,
        ref,
        className: 'spriteIcon'
    };
    return (_jsx("svg", { role: "presentation", viewBox: "0 0 14 15", ...props, children: _jsxs("g", { fill: "none", fillRule: "evenodd", children: [_jsx("circle", { cx: 7, cy: 7.5, r: 7, fill: "#ef6565", className: "primary-color" }), _jsx("path", { fill: "#fff", fillRule: "nonzero", d: "m7.871 4.017c0 .14-.004.268-.014.382-.009.114-.027.294-.054.54l-.533 4.478h-.616l-.533-4.478a8.813 8.813 0 0 1 -.068-.922c0-.347.09-.602.273-.766a.904.904 0 0 1 .622-.246c.265 0 .484.083.66.25.175.166.263.42.263.762zm-1.906 6.629c0-.28.098-.516.294-.707a.979.979 0 0 1 .71-.287c.272 0 .506.096.702.287a.948.948 0 0 1 .294.707.98.98 0 0 1 -.287.713.955.955 0 0 1 -.71.293.97.97 0 0 1 -.712-.29.972.972 0 0 1 -.29-.716z", className: "secondary-color" })] }) }));
});
export default SvgErrorFilled;
//# sourceMappingURL=ErrorFilled.js.map